import { render } from "./ProductNew.vue?vue&type=template&id=1a6c81c3"
import script from "./ProductNew.vue?vue&type=script&lang=js"
export * from "./ProductNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicContainer from "@/components/BasicContainer.vue";
import ButtonDropdown from "@/components/ButtonDropdown.vue";
import FormLabel from "@/components/forms/FormLabel.vue";
import InputError from "@/components/forms/InputError.vue";
import MainCol from "@/components/MainCol.vue";
import PageFooter from "@/components/PageFooter.vue";
import PageGrid from "@/components/PageGrid.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import SideCol from "@/components/SideCol.vue";
script.components = Object.assign({}, { BasicContainer, ButtonDropdown, FormLabel, InputError, MainCol, PageFooter, PageGrid, SecondaryNav, SecondaryTop, SideCol }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicContainer, ButtonDropdown, FormLabel, InputError, MainCol, PageFooter, PageGrid, SecondaryNav, SecondaryTop, SideCol }, script.__o.components);}